import {
  APIProjectResponse,
  APISiteResponse,
  APIUserResponse
} from '../../models'
import { ActionType } from './action'

export type AppStoreProjectFilter = (
  item: APIProjectResponse,
  key: number,
  items: APIProjectResponse[]
) => boolean

export type Store = {
  isLoading: boolean
  project: Partial<APIProjectResponse>
  user: APIUserResponse
  sites: APISiteResponse[]
  areSitesLoading: boolean
  projects: APIProjectResponse[]
  projectsFilter: AppStoreProjectFilter
  areProjectsLoading: boolean
}
export type Action =
  | { type: ActionType.SET_USER; payload: Pick<Store, 'user'> }
  | { type: ActionType.SET_PROJECT; payload: Pick<Store, 'project'> }
  | { type: ActionType.SET_SITES; payload: Pick<Store, 'sites'> }
  | { type: ActionType.SET_IS_LOADING; payload: Pick<Store, 'isLoading'> }
  | { type: ActionType.SET_PROJECTS; payload: Pick<Store, 'projects'> }
  | {
      type: ActionType.SET_ARE_SITES_LOADING
      payload: Pick<Store, 'areSitesLoading'>
    }
  | {
      type: ActionType.SET_ARE_PROJECTS_LOADING
      payload: Pick<Store, 'areProjectsLoading'>
    }
  | {
      type: ActionType.SET_PROJECTS_FILTER
      payload: Pick<Store, 'projectsFilter'>
    }

const initialState: Store = {
  isLoading: true,
  project: {
    id: 0,
    name: '',
    url: ''
  },
  user: {
    id: 0,
    name: '',
    first_name: '',
    last_name: '',
    company: undefined,
    email: '',
    phone: '',
    profile: undefined,
    dashboard: undefined,
    url: '',
    last_activity: ''
  },
  sites: [],
  areSitesLoading: true,
  projects: [],
  areProjectsLoading: true,
  projectsFilter: () => true
}

export default function (state: Store = initialState, action: Action): Store {
  switch (action.type) {
    case ActionType.SET_PROJECT:
      return {
        ...state,
        project: action.payload.project
      }
    case ActionType.SET_USER:
      return {
        ...state,
        user: {
          ...state.user,
          ...action.payload.user
        }
      }
    case ActionType.SET_SITES:
      return {
        ...state,
        sites: action.payload.sites || state.sites
      }
    case ActionType.SET_IS_LOADING:
      return {
        ...state,
        isLoading: !!action.payload.isLoading
      }
    case ActionType.SET_PROJECTS:
      return {
        ...state,
        projects: action.payload.projects
      }
    case ActionType.SET_ARE_SITES_LOADING:
      return {
        ...state,
        areSitesLoading: action.payload.areSitesLoading
      }
    case ActionType.SET_ARE_PROJECTS_LOADING:
      return {
        ...state,
        areProjectsLoading: action.payload.areProjectsLoading
      }
    case ActionType.SET_PROJECTS_FILTER:
      return {
        ...state,
        projectsFilter: action.payload.projectsFilter
      }
    default:
      return state
  }
}
